(ns minorodata.keyboard-shortcuts.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]
            [minorodata.app.posthog-events :as posthog-events]))


;; Both are queued as separate events, so navigation runs first and a capture
;; failure can't drop it.
(defn navigate [_ [shortcut route]]
  {:dispatch-n [[:app.events/navigate route]
                [:posthog/capture {:event (:keyboard-shortcuts/used posthog-events/events)
                                   :props {:shortcut shortcut :destination (name route)}}]]})

(reg-event-fx
 :keyboard-shortcuts.events/navigate
 navigate)
